<template>
  <div class="character-selection">
    <h1>选择你的角色</h1>
    <div class="character-grid">
      <a-card
        v-for="character in characters"
        :key="character.id"
        :title="character.name"
        class="character-card"
        :class="{ selected: selectedCharacter === character.id }"
        @click="selectCharacter(character.id)"
      >
        <template #cover>
          <div class="character-image-placeholder">
            {{ character.name }}
          </div>
        </template>
        <a-card-meta :description="character.description" />
      </a-card>
    </div>
    <a-button
      type="primary"
      size="large"
      :disabled="!selectedCharacter"
      @click="startGame"
    >
      开始游戏
    </a-button>
  </div>
</template>

<script>
import { ref } from 'vue';
import { useRouter } from 'vue-router';

export default {
  name: 'CharacterSelection',
  setup() {
    const router = useRouter();
    const selectedCharacter = ref(null);
    
    // 角色数据
    const characters = [
      {
        id: 'chisato',
        name: '千早爱音',
        description: 'MyGO!!!!!的主唱兼吉他手'
      },
      {
        id: 'muku',
        name: '若叶睦',
        description: 'MyGO!!!!!的贝斯手'
      }
    ];
    
    // 选择角色
    const selectCharacter = (characterId) => {
      selectedCharacter.value = characterId;
    };
    
    // 开始游戏
    const startGame = () => {
      if (selectedCharacter.value) {
        // 跳转到游戏界面，传递选择的角色ID
        router.push({
          name: 'Game',
          query: { character: selectedCharacter.value }
        });
      }
    };
    
    return {
      characters,
      selectedCharacter,
      selectCharacter,
      startGame
    };
  }
};
</script>

<style scoped>
.character-selection {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
}

.character-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 20px;
  margin: 20px 0;
}

.character-card {
  cursor: pointer;
  transition: transform 0.2s;
}

.character-card:hover {
  transform: translateY(-5px);
}

.character-card.selected {
  border-color: #1890ff;
  box-shadow: 0 0 0 2px #1890ff;
}

.character-image-placeholder {
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f0f0f0;
  font-size: 18px;
  font-weight: bold;
}
</style>